module.exports = __webpack_public_path__ + "24e004ab/img/splash-icon.07a7c465.svg";